import {connect} from 'react-redux';
import mapKeys from 'lodash/mapKeys';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {extractResourceIdsWithPath, getBreakResource} from 'utils/DBUtils';
import {saveResourceFieldAction, submitSaveResourceChangelist} from 'resources/actions';
import {newRuleAutoSaveSelector, editRuleAutoSaveSelector} from './selectors';
import DynamicContentRules from './DynamicContentRules';
import {dynamicContentRuleFactory} from './utils';

const mapStateToProps = (state, props) => {
  // dynamic content is currently supported on MASTER only.
  const masterBreakId = state.editBreak.break.MASTER;
  const masterBreak = state.resources.resources[masterBreakId];

  // path to the current resource list item.
  const {resourcePath} = props.formProxy;

  // resource list item: listicle item, filtering option, maybe others in the future.
  const resource = getBreakResource(masterBreak, masterBreak, resourcePath);

  // make sure we don't pass down any funky intermediate save states as a dynamics list.
  // we can discern such states via type check: valid dynamics lists are only ever arrays.
  //
  // FIXME: maybe this can be handled generically in the `resources` reducer?
  resource.dynamics = Array.isArray(resource.dynamics) ? resource.dynamics : [];

  // resource hierarchy stuff needed for save calls.
  const parentIds = extractResourceIdsWithPath(masterBreak, masterBreak, resourcePath);

  // props needed for rendering this field and its components.
  const fieldProps = {
    ...props.field.props,
    required: props.field.required
  };

  // get auto-save statuses for creates and edits in progress.
  const saveStatuses = editRuleAutoSaveSelector(resource)(state.resources);
  const newRuleStatus = newRuleAutoSaveSelector(resource.id)(state.resources);

  return {
    ...fieldProps,
    resource,
    masterBreak,
    resourcePath,
    parentIds,
    saveStatuses,
    newRuleStatus
  };
};

const mapDispatchToProps = {
  saveResourceFieldAction,
  submitSaveResourceChangelist
};

export default compose(
  setDisplayName('DynamicContentRulesContainer'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    // call for creating or deleting a dynamic content rule, or for editing a
    // single field on a dynamic content rule.
    const saveField = (field, value) => props.saveResourceFieldAction(
      props.resource.resourceId,
      props.masterBreak.resourceId,
      props.resourcePath,
      props.resourcePath.concat(field),
      field,
      value,
      props.parentIds,
      null,
      null,
      true,
      {}
    );

    // call for editing multiple fields on a dynamic content rule.
    const saveChangelist = changelist => props.submitSaveResourceChangelist(
      props.resource.resourceId.type,
      props.resource.resourceId.id,
      changelist,
      props.masterBreak.resourceId.id,
      props.resourcePath,
      props.parentIds,
      {}
    );

    return {
      // CRUD operations.
      onAddRule: () => saveField('dynamics.#', JSON.stringify(
        dynamicContentRuleFactory(props.resource.supportedDynamicActions)
      )),

      onRemoveRule: index => saveField(`dynamics.X${index}`),

      onActionChange: (index, event, {value}) => saveField(`dynamics.${index}.action`, value),

      // this dropdown's changes get handled as a resource save changelist action, since
      // we need to set both the stepId and the resultId.
      onResultChange: (index, event, {value}) => {
        // find the corresponding stepId for this value (resultId).
        const {stepId: section} = props.resource.supportedOptions.find(opt => opt.resultId === value);

        // scope changelist field names to their corresponding dynamic content rule.
        const changelist = mapKeys({section, value}, (_, field) => `dynamics.${index}.${field}`);
        saveChangelist(changelist);
      }
    };
  })
)(DynamicContentRules);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DynamicContentRules/DynamicContentRulesContainer.js